import { IExperiment } from '../types/experiments';

export enum EPropertyGuidesGroups {
  /* Контрольная группа, никаких изменений */
  Empty = 0,
  /* Упрощенный вариант категорий жизненных ситуаций на главной странице */
  Simple = 1,
  /* Гламурный вариант категорий жизненных ситуаций на главной странице */
  Glamour = 2,
}

export const getPropertyGuidesGroup = (experiments: IExperiment[]): EPropertyGuidesGroups => {
  const propertyGuidesGroup = experiments.find(({ name }) => name === 'main_page_property_guides') || {
    abGroup: EPropertyGuidesGroups.Empty,
  };

  return propertyGuidesGroup.abGroup;
};
